// @ts-strict
import {useMemo} from 'react';

import {type ContactUsOrderFragment, useContactUsFormQuery} from '@/graphql/types';
import formatOrderLabel from '../formatOrderLabel';

type UseSupportMessageOrderOptions = {skip: boolean};

const useSupportMessageOrderOptions = ({
  skip,
}: UseSupportMessageOrderOptions): {value: string; label: string}[] => {
  const {data} = useContactUsFormQuery({partialRefetch: true, errorPolicy: 'all', skip});
  const recentOrders = data?.me?.consumerAccount?.orders?.nodes;

  return useMemo(() => {
    if (!recentOrders) return [];

    return recentOrders
      .filter((order): order is ContactUsOrderFragment => order != null)
      .map(order => {
        const label = formatOrderLabel(order);
        const orderNumber = order.formattedOrderNumber;

        // Salesforce shows this to an agent, so send the order number rather than an internal id.
        return {label, value: !orderNumber || orderNumber === '#' ? label : orderNumber};
      });
  }, [recentOrders]);
};

export default useSupportMessageOrderOptions;
